import $ from "jquery";
import 'slick-carousel';

document.addEventListener('DOMContentLoaded', function () {
    let options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };

    let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            var $slider = $(entry.target);
            if (entry.isIntersecting) {
                if ($slider.find('img').length > 1) {
                    $slider.slick('slickPlay');
                }
            } else {
                $slider.slick('slickPause');
            }
        });
    }, options);

    $('.illumi-img__slider').each(function() {
        var $slider = $(this);
        if ($slider.find('img').length > 1) {
            $slider.slick({
                autoplay: true,
                autoplaySpeed: 4000,
                fade: true,
                arrows: false,
                dots: true,
            }).slick('slickPause');
            observer.observe(this);
        } else {
            $slider.addClass('is-inactive');
        }
    });
});
